export default __webpack_public_path__ + "static/media/up-arrow.b5538340.webp";